import { colors } from "../../Styles";

export function Clear({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <polygon points="210.34 162.8 201.15 153.61 178.17 176.59 155.19 153.61 146 162.8 168.98 185.78 146 208.76 155.19 217.95 178.17 194.98 201.15 217.95 210.34 208.76 187.36 185.78 210.34 162.8"/>
      <path d="M250.4,56.9H33.06c-3.91,0-6.11,4.49-3.72,7.59l74.52,96.25c.64.82.98,1.84.98,2.88v58.25c0,2.6,2.11,4.71,4.71,4.71h64.37c2.6,0,4.71-2.11,4.71-4.71v-20.58l-.2-.2-22.98,22.98-15.56-15.55,22.98-22.98-22.98-22.98,15.56-15.55,22.98,22.98.2-.2v-6.16c0-1.04.35-2.06.98-2.88l74.52-96.25c2.39-3.09.19-7.59-3.72-7.59Z"/>
    </svg>
  );
}
